import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

import './App.css';
import { BookmarkletLink } from './component/BookmarkletLink';
import { History } from './component/history/History';
import { Qlip } from './component/Qlip';
import { SignUp } from './component/auth/SignUp';
import { Login } from './component/auth/Login';
import { Dashboard } from './component/Dashboard';
import { TestInput } from './component/TestInput';
import { getToken } from './helper/token';
import reactLogo from './logo.svg';
import qlippedLogo from './logo.png'; // Using PNG for the actual Qlipped logo

import input from './content/test.md';
import * as ReactRouterDOM from 'react-router-dom';
const BrowserRouter = (ReactRouterDOM as any).BrowserRouter;
const Switch = (ReactRouterDOM as any).Switch;
const Route = (ReactRouterDOM as any).Route;

function printEnv(label: string) {
  Object.keys(process.env).forEach((key, i) => {
    console.log(`${label} - ${i} - ${key}:`, process.env[key]);
  });
}

function App() {
  const label = `App`;
  const [markdown, setMarkdown] = useState(input);
  const [token] = useState(getToken());
  useEffect(() => {
    const prefix = `${label}.useEffect`;
    console.log(prefix);
    printEnv(prefix);
    fetch(input)
      .then((response) => response.text())
      .then((markdown) => setMarkdown(markdown));
  });
  const isStaging = window.location.hostname.includes('stg');
  console.log('isStaging:', isStaging);

  const urlParams = new URLSearchParams(window.location.search);
  const version = urlParams.get('version');
  console.log('version:', version);

  if (!isStaging && version !== 'alpha') {
    return (
      <div className="App production">
        <header className="App-header">
          <img src={reactLogo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.tsx</code> and save to reload!
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </header>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        {/* Sticky Header with Qlipped Button */}
        <header className="sticky-header">
          <div className="header-content">
            <div className="header-left">
              <a href="/" className="header-logo-link">
                <img src={qlippedLogo} className="header-logo-img" alt="Qlipped" />
              </a>
            </div>
            <div className="header-center">
              <div className="header-cta">
                <BookmarkletLink token={token} />
                <span className="header-instruction"><span role="img" aria-label="point left">👈</span> Drag to bookmark bar</span>
              </div>
            </div>
            <div className="header-right">
              <nav className="header-nav">
                <a href="/login" className="nav-link">Log In</a>
                <a href="/signup" className="nav-button">Sign Up</a>
              </nav>
            </div>
          </div>
        </header>

        <Switch>
          <Route exact path="/">
            <div className="home-page">
              {/* Hero Section */}
              <section className="hero-section">
                <div className="hero-content">
                  <h1 className="hero-title">Save Any Web Page Instantly</h1>
                  <p className="hero-subtitle">
                    Your bookmarklet is ready in the header above - drag it to your bookmark bar and start saving pages with one click!
                  </p>
                </div>
              </section>

              {/* Features Section */}
              <section className="features-section">
                <div className="features-content">
                  <h2>Why Choose Qlipped?</h2>
                  <div className="features-grid">
                    <div className="feature-card">
                      <div className="feature-icon"><span role="img" aria-label="lightning bolt">⚡</span></div>
                      <h3>Instant Bookmarking</h3>
                      <p>Save any web page with a single click from your bookmark bar</p>
                    </div>
                    <div className="feature-card">
                      <div className="feature-icon"><span role="img" aria-label="magnifying glass">🔍</span></div>
                      <h3>Smart Extraction</h3>
                      <p>Automatically captures page titles, descriptions, and metadata</p>
                    </div>
                    <div className="feature-card">
                      <div className="feature-icon"><span role="img" aria-label="mobile phone">📱</span></div>
                      <h3>Cross-Platform</h3>
                      <p>Works on any device with a web browser</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* How It Works */}
              <section className="how-it-works-section">
                <div className="how-it-works-content">
                  <h2>How It Works</h2>
                  <div className="steps">
                    <div className="step">
                      <div className="step-number">1</div>
                      <div className="step-content">
                        <h3>Drag the Button</h3>
                        <p>Drag the Qlipped button above to your browser's bookmark bar</p>
                      </div>
                    </div>
                    <div className="step">
                      <div className="step-number">2</div>
                      <div className="step-content">
                        <h3>Visit Any Page</h3>
                        <p>Navigate to any web page you want to bookmark</p>
                      </div>
                    </div>
                    <div className="step">
                      <div className="step-number">3</div>
                      <div className="step-content">
                        <h3>Click to Save</h3>
                        <p>Click the Qlipped button in your bookmark bar to save the page</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Optional: Legacy content for testing */}
              <section className="legacy-content" style={{ display: 'none' }}>
                <ReactMarkdown source={markdown} />
              </section>
            </div>
          </Route>
          <Route exact path="/signup">
            <SignUp />
          </Route>
          <Route exact path="/login">
            <TestInput />
            <Login />
          </Route>
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/q/:token" component={Qlip} />
          <Route exact path="/history/:token" component={History} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
